<template>
    <div class="flex-cell" :class="{flex, center, vcenter, 'align-bottom':alignBottom, shrink}">
        <slot></slot>
    </div>
</template>
<script>

export default {
    props:{
        flex:{type:Boolean},
        center:{type:Boolean},
        vcenter:{type:Boolean},
        alignBottom:{type:Boolean},
        shrink:{type:Boolean},
    },
}

</script>
<style scoped lang="scss">
.flex-cell {
    // overflow: hidden;
    flex: 1;
    flex-direction: row;

    &.flex {
        display: flex;
    }

    &.center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.vcenter {
        display: flex;
        align-items: center;
    }

    &.align-bottom {
        display: flex;
        align-items: self-end;
    }

    &.shrink {
        flex:none;
    }
}



</style>